import { Box, CircularProgress } from '@mui/material'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../state/AuthContext'

/** Só entra quem tem a permissão (ou uma delas); os demais voltam para o início. O banco barra de qualquer jeito. */
export function RequirePermissao({ permissao }: { permissao: string | string[] }) {
  const { pode, permissoesCarregando } = useAuth()

  if (permissoesCarregando) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  const permitido = Array.isArray(permissao) ? permissao.some(pode) : pode(permissao)
  return permitido ? <Outlet /> : <Navigate to="/" replace />
}
